<template>
  <div class="quality-template">
    <div class="category">
      <span class="category-item" 
        :class="{active: category_id == item.category_id}"
        v-for="item,index in categoryList"
        @click="clickCategory(item)"
        :key="index">{{item.category_name}}</span>
    </div>
    <div class="list">
      <div class="item" v-for="item,index in list" :key="index">
        <div class="left" v-if="speakerMap && speakerMap[item.dubbing_param.speaker_id]">
          <img class="dubber-image" :src="speakerMap[item.dubbing_param.speaker_id].image" alt="" />
          <div class="dubber-name">{{speakerMap[item.dubbing_param.speaker_id].name}}</div>
        </div>
        <div class="center">
          <div class="title">{{item.dubbing_param.dubbing_name}}</div>
          <div class="info">{{ item.dubbing_param.text }}</div>
        </div>
        <div class="right">
          <SvoiceTooltip :title="!audioFlag || (currentIndex !== index) ? '播放' : '暂停'">
            <img class="play-small audio-image" @click="()=>clickAudioButton(item, index, !audioFlag || (currentIndex !== index))" :src="!audioFlag || (currentIndex !== index) ? playImage : stopImage" alt="">
          </SvoiceTooltip>
          <!-- <SvoiceTooltip title="暂停">
            <img class="stop-small audio-image" v-show="audioFlag && (currentIndex === index)" @click="()=>stopAudio(item, index)" src="@/assets/images/stop_small.png" alt="">
          </SvoiceTooltip> -->
          <span class="editor" @click="()=>eidtorTemplate(item)">
            <SvoiceTooltip title="编辑">
              <svg-icon name="editor_big"></svg-icon>
            </SvoiceTooltip>
          </span>
        </div>
      </div>
    </div>
    <footer>
      <Pagination @jump="getList" :resetPage="resetPage" :total="total"></Pagination>
    </footer>
  </div>
</template>

<script>
import Pagination from 'components/pagination.vue'
import { getDubTpl, getDubCate } from '@/api/dub-example.js'
import { getSpeakersMap } from 'utils/model.js'
import { mixin } from 'utils/audio-mixin.js'
import { scrollTop } from 'utils/utils.js'
import SvoiceTooltip from '@/components/svoice-tooltip.vue'
const playImage = require('@/assets/images/play_small.png')
const stopImage = require('@/assets/images/stop_small.png')

export default {
  name: 'quality-template',
  props: {
    msg: String
  },
  components: {
    Pagination,
    SvoiceTooltip
  },
  mixins: [mixin],
  data() {
    return {
      categoryList: [],
      category_id: 0,
      resetPage: false,
      list: [],
      speakerMap: {},
      total: 0,
      currentIndex: -1,
      playImage,
      stopImage
    }
  },
  created() {
    this.getSpeakersMap()
    this.getDubCate()
  },
  methods: {
    clickAudioButton (item, index, flag) {
      if (!item) {
        return
      }
      if (flag) {
        this.audioFlag = true
        this.currentIndex = index
        this.audio.src = item.dubbing_param.audio_url
        this.audio.play()
      } else {
        this.audioFlag = false
        this.currentIndex = -1
        this.audio.pause()
      }
      console.log(item,index)
    },
    // stopAudio (item,index) {
    //   console.log(item,index)
    //   this.audioFlag = false
    //   this.currentIndex = -1
    //   this.audio.pause()
    // },
    async getSpeakersMap () {
      this.speakerMap = await getSpeakersMap()
    },
    clickCategory(item) {
      console.log(item)
      this.category_id = item.category_id
      this.resetPage = true
    },
    async getList (page) {
      this.audio && this.audio.pause()
      page.category_id = this.category_id
      this.resetPage = false
      const res = await getDubTpl(page)
      const {list, total} = res.data
      this.list = list
      this.total = total
      scrollTop(0)
    },
    async getDubCate () {
      const res = await getDubCate()
      this.categoryList = res.data;
    },
    eidtorTemplate (item) {
      console.log(item)
      this.$store.dispatch('global/setRegenerateFlag', true)
      this.$store.dispatch('global/setDubbingParams', item.dubbing_param)
      this.$router.push('/maker/create')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.quality-template {
  padding: 40px;
  .category {
    font-size: 14px;
    color: #999;
    .category-item {
      padding: 2px 5px;
      border-radius: 4px;
      margin: 0 5px 5px 0;
      display: inline-block;
      min-width: 70px;
      text-align: center;
      cursor: pointer;
      &.active {
        color: #FFFFFF;
        background-color: #4E6EFF;
      }
    }
  }
  .list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .item {
      min-width: 530px;
      width: 49%;
      border: 1px solid #EEEEEE;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: #555555;
      padding: 20px;
      box-sizing: border-box;
      margin-top: 20px;
      .left {
        text-align: center;
        .dubber-image {
          width: 50px;
          height: 50px;
          display: block;
          margin-bottom: 5px;
          display: block;
          border-radius: 25px;
        }
      }
      .center {
        flex: 1;
        padding: 0 25px;
        font-size: 14px;
        color: #555;
        line-height: 20px;
        .info {
          color: #999999;
          margin-top: 5px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
      .right {
        display: flex;
        align-items: center;
        .audio-image {
          width: 30px;
          height: 30px;
          cursor: pointer;
        }
        .editor {
          width: 26px;
          height: 26px;
          margin-left: 20px;
        }
        .svg-icon--editor_big {
          width: 26px;
          height: 26px;
          cursor: pointer;
          &:hover {
            filter: invert(85%) sepia(80%) saturate(2500%) hue-rotate(200deg) brightness(85%) contrast(350%);
          }
        }
      }
    }
  }
  footer {
    margin-top: 18px;
  }
}
</style>
